import React, { FunctionComponent, useMemo } from "react";
import PdfBtn from "./PdfBtn";
import {
  AcademicConcernTypeInterventionDisplayedNames,
  ConcernArea,
  ConcernTypeInterventionDisplayedIcon,
  ExpectedChangeDisplayedNames,
  ExpectedChangeInterventionDisplayedIcon,
  ExtendedInterventionTargetDisplayedIcon,
  ExtendedInterventionTargetDisplayedNames,
  Intervention,
  InterventionTargetDisplayedIcon,
  InterventionTargetDisplayedNames,
} from "../../../../../../store/onboarding/cases/types";
import { useIntl } from "react-intl";
import useCreatedBy from "../../../../../../utils/hooks/useCreatedBy";
import { faCheck, faCheckCircle, faStarOfLife, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

type OwnProps = {
  intervention: Intervention;
  onSelect: (intervention: Intervention) => any;
  isSelected?: boolean;
};

type Props = OwnProps;

const InterventionItem: FunctionComponent<Props> = ({
  intervention,
  onSelect,
  isSelected,
}) => {
  const intl = useIntl();

  const isAcademic = useMemo(
    () => intervention.concern_area === ConcernArea.ACADEMIC,
    [intervention.concern_area]
  );

   const platformName = useMemo(
    () => "ReadyCoach",
    []
  );

  const { createdBy } = useCreatedBy(intervention.created_by_user);

  return (
    <div
      data-cy="intervention-item"
      className="interventionItem"
      onClick={() => onSelect(intervention)}
      key={intervention.id}
      style={isSelected ? { border: "2px solid limegreen" } : undefined}
    >
      {isSelected && (
        <div className="align-self-start ml-2 mt-2 color-limegreen">
          <FontAwesomeIcon icon={faCheckCircle} /> Added to Intervention Plan
        </div>
      )}
      <div className="interventionItemBody row">
        <div className="interventionItemDescription col-md-8 mr-0 pr-0">
          <div className="d-flex align-items-center">
            <div className="interventionItemIcon">
              {intervention.concern_area === 0 ? "A" : "B"}
            </div>
            <h3>{intervention.name}</h3>
          </div>
          <p className="mb-0">{intervention.description}</p>
          {
            ((!isAcademic && intervention.expected_change != undefined) ||
            intervention.concern_type != undefined ||
            intervention.target != undefined) && (
            <>
              {/* --- New Button Row as per image --- */}
              <div className="d-flex align-items-center flex-wrap">
                  {!isAcademic && (intervention.expected_change !== null) ? (
                    <span
                      className="d-inline-flex align-items-center flex-nowrap mt-2 mr-2 px-2 py-1 border border-secondary rounded bg-white"
                      style={{ fontWeight: 500, fontSize: 14, opacity: 1, cursor: "default" }}
                    >
                        <span className="mr-1" role="img" aria-label="Small Groups">
                          <FontAwesomeIcon icon={ExpectedChangeInterventionDisplayedIcon[intervention.expected_change] as IconProp} />
                        </span>
                        {ExpectedChangeDisplayedNames[intervention.expected_change]}
                    </span>
                  ): null}
                  {intervention.concern_type !== null ? (
                    <span
                      className="d-inline-flex align-items-center flex-nowrap mt-2 mr-2 px-1 py-1 border border-secondary rounded bg-white"
                      style={{ fontWeight: 500, fontSize: 14, opacity: 1, cursor: "default" }}
                    >
                      <span className="mr-1">
                       <FontAwesomeIcon icon={ConcernTypeInterventionDisplayedIcon[intervention.concern_type] as IconProp} />
                      </span>
                      {AcademicConcernTypeInterventionDisplayedNames[intervention.concern_type]}
                    </span>
                  ): null}
                  {intervention.target !== null ? (
                    <span
                      className="d-inline-flex align-items-center flex-nowrap mt-2 px-1 py-1 mr-0 border border-secondary rounded bg-white"
                      style={{ fontWeight: 500, fontSize: 14, opacity: 1, cursor: "default" }}
                    >
                      <span className="mr-1">
                        <FontAwesomeIcon icon={
                          InterventionTargetDisplayedIcon[intervention.target] as IconProp
                          || ExtendedInterventionTargetDisplayedIcon[intervention.target] as IconProp} />
                      </span>
                      {InterventionTargetDisplayedNames[intervention.target] 
                      || ExtendedInterventionTargetDisplayedNames[intervention.target] || ""}
                    </span>
                  ): null}
              </div>
              {/* --- End Button Row --- */}
            </>
            )}
        </div>
        <div className={`col-md-4 ml-0 px-0 mt-2 mr-4 d-flex justify-content-end`}>
          <PdfBtn intervention={intervention} />
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-end ml-3">
        <div>
          <p className="m-0 py-2">
            {intl.formatMessage({
              id: "app.dashboard.interventions.filters.createdBy.label",
            })}
            &nbsp;
            <strong>{(createdBy && createdBy.trim()) || platformName}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default InterventionItem;
